declare global {
  interface Window {
    octadesk?: {
      chatOptions?: Record<string, unknown>
      chat?: {
        open?: () => void
        toggle?: () => void
        close?: () => void
        showApp?: () => void
        hideApp?: () => void
        apps?: Record<string, {
          toggleApp?: () => void
          showApp?: () => void
          hideApp?: () => void
        }>
      }
    }
  }
}

export function invokeOctadeskShow (): void {
  const chat = window.octadesk?.chat
  if (!chat) {
    return
  }

  if (typeof chat.showApp === 'function') {
    chat.showApp()
    return
  }

  chat.apps?.chat?.showApp?.()

  if (typeof chat.toggle === 'function') {
    chat.toggle()
  }
}

export function invokeOctadeskHide (): void {
  const chat = window.octadesk?.chat
  if (!chat) {
    return
  }

  if (typeof chat.hideApp === 'function') {
    chat.hideApp()
    return
  }

  chat.apps?.chat?.hideApp?.()

  if (typeof chat.toggle === 'function') {
    chat.toggle()
  }
}

export {}
